<!--
 * @Description: 模板单项组件
 * @Autor: WangYuan
 * @Date: 2021-05-31 11:55:13
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-01-27 19:43:23
-->
<template>
  <div
    :class="{ active: mode.mValue[1] == value }"
    class="select-viewMore mt5 flex_box"
    @click="bindChange(value)"
  >
    <div :style="[viewMoreStyle(value)]" class="flex_box">
      <div>{{ value == "four" || value == "five" ? "" : "查看更多" }}</div>
      <div :class="{ circle: value == 'five' }" class="flex_box">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "select-see-more",

  props: ["label", "value", "icon"],

  inject: ["mode"],

  methods: {
    bindChange(val) {
      if (this.value[1] == val) return;
      this.mode.mValue = [this.mode.mValue[0], val];
      this.$forceUpdate();
    },

    viewMoreStyle(type) {
      let result = {
        fontSize: "12px",
        textAlign: "center",
        borderRadius: "5px",
        padding: `5px 10px`,
        color: "#999",
      };
      if (type == "one" || type == "two") {
        result.border = "1px solid #eee";
        if (type == "one") {
          result.borderRadius = "5px";
        } else {
          result.borderRadius = "30px";
        }
      } else if (type == "three" || type == "four") {
        result.border = "1px solid transparent";
      } else {
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";
.flex_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle {
  width: 22px;
  height: 22px;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 1);
}
</style>
